import { createSlice } from "@reduxjs/toolkit";

// Sized to the longest nav label plus its gutter, not a round number: the rows
// were tightened, and leaving the drawer at 200px just moved the wasted space
// from between the icon and the label to the right of it. Measured with Poppins
// loaded, the longest label ("Management") renders at 97.5px in a 107px box, so
// there is ~9px of headroom: re-measure before adding a longer nav label, or it
// will silently ellipsise.
const DRAWER_WIDTH_OPEN = 176;
const DRAWER_WIDTH_COLLAPSED = 55;

export interface LayoutState {
  drawerOpen: boolean;
  drawerWidth: number;
}

const initialState: LayoutState = {
  drawerOpen: true,
  drawerWidth: DRAWER_WIDTH_OPEN,
};

const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    toggleDrawer: (state) => {
      state.drawerOpen = !state.drawerOpen;
      if (state.drawerOpen) {
        state.drawerWidth = DRAWER_WIDTH_OPEN;
      } else {
        state.drawerWidth = DRAWER_WIDTH_COLLAPSED;
      }
    },
  },
});

export default layoutSlice.reducer;
export const { toggleDrawer } = layoutSlice.actions;
